const _ = require('lodash');

const getQueryParameterByName = require('../helpers/GetQueryParam');

var variantId = _.get(document.referrer.match('\/p\/(V\-[0-9]+)'), 1) || document.getElementById('uc-loader').getAttribute('data-variant-id');
const domain = _.get(document.referrer.match('\/\/([a-z0-9\.\-]+)\/'), 1);
const url = document.referrer;

console.log("Variant id: ", variantId);

const ZalesLoader = {
  productId: getQueryParameterByName('id'),
  configId: _.get(location.search.match('configId=CFG[0-9]{5,7}0([0-9]+)'), 1),
  siteId: getQueryParameterByName('hs'),
  userId: getQueryParameterByName('hu'),
  cartId: getQueryParameterByName('hc'),
  envId: getQueryParameterByName('he'),
  variantId,
  domain,
  url,
  addToCartUrl: false
};

if (variantId == null) {
  const Loader = require('./index.js');
  setTimeout(() => {
    Loader.default.variantId = _.get(document.referrer.match('\/p\/(V\-[0-9]+)'), 1) || document.getElementById('uc-loader').getAttribute('data-variant-id');
    console.log('Loader: ', Loader);
  }, 5000); // 15000 - in prod now, 20000 - in QA now
}

export default ZalesLoader;


// WEBPACK FOOTER //
// ./src/base/scripts/loaders/signet.js